import { render } from "./CreateNewFileOverlay.vue?vue&type=template&id=28685bf4"
import script from "./CreateNewFileOverlay.vue?vue&type=script&lang=js"
export * from "./CreateNewFileOverlay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__